import Classroom from '../pages/classroom/index.vue'//导师课堂
import ClassroomDetail from '../pages/classroom/detail.vue'//导师课堂详情
import ClassroomHistory from '../pages/classroom/history.vue'//导师课堂购买详情
const routes = [
  {
    path: '/classroom',
    name: 'Classroom',
    component: Classroom,
  },
  {
    path: '/classroom_detail',
    name: 'classroom_detail',
    component: ClassroomDetail,
  },
  {
    path: '/classroom_history',
    name: 'classroom_history',
    component: ClassroomHistory,
  },
];
export default routes